
/* ratio is to get the gcd and divide each component by the gcd, then return a string with the typical colon-separated value */
export function ratio(x, y) {
    return +(x / y).toFixed(1);
}

export function loadImagePromise(src) {
    return new Promise((resolve) => {
        let img = new Image()
        img.onload = () => resolve(img)
        img.onerror = () => resolve(null)
        img.src = src
    })
}
